import axios from 'axios';
import { toast } from "react-toastify";

let api = axios.create({
  baseURL: process.env.REACT_APP_URL_API,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config: any) => {
  let usuario = localStorage.getItem("user-store");
  if (usuario && !config.url.includes('dstore-dev-data.s3')) {
    let user = JSON.parse(usuario)

    try {
      config.headers['Authorization'] = `Bearer ${user.token}`;
    } catch (e) {
      console.log(`Erro no token: ${e}`);
    }
  } 

  return config;
});

api.interceptors.response.use((response: any) => {
  return response;
}, (error: any) => {
  if (error.response && error.response.data) {
    if (typeof error !== 'undefined') {
      if (error.response.status === 500) {
        toast.error("Ocorreu um erro na sua solicitação. Entre em contato com o suporte.", { autoClose: false });
      }
      if (error.response.status === 401 || error.response.status === 403 ) {
       
        localStorage.clear()
        window.location.href = '/login'
        
      }     
    }
  }

  return Promise.reject(error)
})

export default api;